import { Observable } from 'rxjs';
import {
  TpvDashboardQuery,
  TpvDashboardSummary,
} from '@app/domain/models/tpv/tpv-dashboard-summary.model';

/**
 * Port de lectura del Dashboard de TPV.
 *
 * Una sola responsabilidad: devolver el resumen agregado para el filtro dado
 * (rango de fechas y, opcionalmente, un comercio). Implementaciones remota/mock
 * se inyectan vía `TPV_REST_PROVIDERS` según `environment.tpvUseMocks`.
 */
export abstract class TpvDashboardRepository {
  abstract getDashboard(query?: TpvDashboardQuery): Observable<TpvDashboardSummary>;
}
